export const ValidationMessages = {
  REQUIRED: 'This field is required.',
  MIN_LENGTH: (min: number) => `Minimum length is ${min} characters.`,
  MAX_LENGTH: (max: number) => `Maximum length is ${max} characters.`,
  EMAIL: 'Invalid email address format.',
  PATTERN: 'Invalid format.',

  // Login
  USERNAME_REQUIRED: 'Username is required.',
  USERNAME_MIN_LENGTH: 'Username must be at least 3 characters.',
  PASSWORD_REQUIRED: 'Password is required.',
  PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters.',

  // User Form
  EMAIL_REQUIRED: 'Email address is required.',
  FIRST_NAME_REQUIRED: 'First name is required.',
  LAST_NAME_REQUIRED: 'Last name is required.',
  PRIMARY_MOBILE_REQUIRED: 'Primary mobile number is required.',
  ORGANIZATION_REQUIRED: 'At least one organization assignment is required.',
  LOCATION_REQUIRED: 'At least one location assignment is required.',
  ROLE_REQUIRED: 'At least one role assignment is required.',

  // Tenant Form
  TENANT_NAME_REQUIRED: 'Tenant name is required.',
  TENANT_NAME_MIN_LENGTH: 'Must be at least 3 characters.',
  TENANT_CODE_REQUIRED: 'Code is required.',
  TENANT_CODE_MAX_LENGTH: 'Cannot exceed 30 characters.',
  TENANT_CODE_PATTERN: 'Must contain alphanumeric values or hyphens/underscores only.',

  // Organization Form
  ORGANIZATION_NAME_REQUIRED: 'Organization name is required.',
  ORGANIZATION_CODE_REQUIRED: 'Organization code is required.',
  GST_REQUIRED: 'GST number is required.',
  GST_PATTERN: 'Invalid GST format (e.g. 27AAAAA1111A1Z1).',
  PAN_REQUIRED: 'PAN number is required.',
  PAN_PATTERN: 'Invalid PAN format (e.g. AAAAA1111A).',
  TENANT_REQUIRED: 'Tenant association is required.',

  // Location Form
  LOCATION_NAME_REQUIRED: 'Location name is required.',
  LOCATION_CODE_REQUIRED: 'Location code is required.',
  LOCATION_CODE_MAX_LENGTH: 'Cannot exceed 30 characters.',
  LOCATION_CODE_PATTERN: 'Must contain alphanumeric values or hyphens/underscores only.',
  LOCATION_TENANT_REQUIRED: 'Tenant association is required.',
  LOCATION_ORG_REQUIRED: 'Organization association is required.',
  LOCATION_TYPE_REQUIRED: 'Location type is required.',

  // Role Form
  ROLE_NAME_REQUIRED: 'Role name is required.',
  ROLE_NAME_MIN_LENGTH: 'Must be at least 3 characters.',
  ROLE_NAME_MAX_LENGTH: 'Cannot exceed 100 characters.',
  ROLE_DESC_MAX_LENGTH: 'Description cannot exceed 255 characters.',
  ROLE_TENANT_REQUIRED: 'Tenant association is required.',
  ROLE_ORG_REQUIRED: 'Organization association is required.',

  // Location Type Form
  LOCATION_TYPE_NAME_REQUIRED: 'Location type name is required.',
  LOCATION_TYPE_NAME_MIN_LENGTH: 'Must be at least 3 characters.',
  LOCATION_TYPE_NAME_MAX_LENGTH: 'Cannot exceed 100 characters.',
  LOCATION_TYPE_TENANT_REQUIRED: 'Tenant association is required.',
  LOCATION_TYPE_ORG_REQUIRED: 'Organization association is required.',

  // Menu Form
  MENU_NAME_REQUIRED: 'Menu name is required.',
  MENU_NAME_MIN_LENGTH: 'Must be at least 3 characters.',
  MENU_NAME_MAX_LENGTH: 'Cannot exceed 100 characters.',
  MENU_TYPE_REQUIRED: 'Menu type classification is required.',

  // Service Form
  SERVICE_NAME_REQUIRED: 'Service name is required.',
  SERVICE_CODE_REQUIRED: 'Service code is required.',
  SERVICE_CODE_MAX_LENGTH: 'Service code cannot exceed 30 characters.',

  // Module Form
  MODULE_NAME_REQUIRED: 'Module name is required.',
  MODULE_CODE_REQUIRED: 'Module code is required.',
  MODULE_CODE_MAX_LENGTH: 'Module code cannot exceed 30 characters.',
  MODULE_SERVICE_REQUIRED: 'Parent service association is required.',
  // Financial Year Form
  FINANCIAL_YEAR_CODE_REQUIRED: 'Financial year code is required.',
  FINANCIAL_YEAR_CODE_MAX_LENGTH: 'Code cannot exceed 30 characters.',
  FINANCIAL_YEAR_CODE_PATTERN: 'Must contain alphanumeric values or hyphens/underscores only.',
  FINANCIAL_YEAR_START_DATE_REQUIRED: 'Start date is required.',
  FINANCIAL_YEAR_END_DATE_REQUIRED: 'End date is required.',
  FINANCIAL_YEAR_DATE_INVALID: 'End date must be on or after start date.',
  FINANCIAL_YEAR_TENANT_REQUIRED: 'Tenant association is required.',
  FINANCIAL_YEAR_ORG_REQUIRED: 'Organization association is required.',

  // Series Master Form
  SERIES_CODE_REQUIRED: 'Series code is required.',
  SERIES_CODE_MAX_LENGTH: 'Series code cannot exceed 20 characters.',
  SERIES_CODE_PATTERN: 'Must contain alphanumeric values or hyphens/underscores only.',
  SERIES_NAME_REQUIRED: 'Series name is required.',
  SERIES_NAME_MAX_LENGTH: 'Series name cannot exceed 100 characters.',
  SERIES_MENU_REQUIRED: 'Target menu association is required.',
  SERIES_TENANT_REQUIRED: 'Tenant association is required.',
  SERIES_ORG_REQUIRED: 'Organization association is required.',
  SERIES_PADDING_MIN: 'Padding must be greater than 0.',

  // Item Category Form
  ITEM_CATEGORY_CODE_REQUIRED: 'Category code is required.',
  ITEM_CATEGORY_CODE_MAX_LENGTH: 'Category code cannot exceed 30 characters.',
  ITEM_CATEGORY_NAME_REQUIRED: 'Category name is required.',
  ITEM_CATEGORY_NAME_MAX_LENGTH: 'Category name cannot exceed 100 characters.',
  ITEM_CATEGORY_DESC_MAX_LENGTH: 'Description cannot exceed 255 characters.',
  ITEM_CATEGORY_TENANT_REQUIRED: 'Tenant association is required.',
  ITEM_CATEGORY_ORG_REQUIRED: 'Organization association is required.',

  // Item Brand Form
  ITEM_BRAND_CODE_REQUIRED: 'Brand code is required.',
  ITEM_BRAND_CODE_MAX_LENGTH: 'Brand code cannot exceed 30 characters.',
  ITEM_BRAND_NAME_REQUIRED: 'Brand name is required.',
  ITEM_BRAND_NAME_MAX_LENGTH: 'Brand name cannot exceed 100 characters.',
  ITEM_BRAND_DESC_MAX_LENGTH: 'Description cannot exceed 255 characters.',
  ITEM_BRAND_TENANT_REQUIRED: 'Tenant association is required.',
  ITEM_BRAND_ORG_REQUIRED: 'Organization association is required.',
} as const;

export const ResponseMessages = {
  // Login
  LOGIN_SUCCESS: (fullName: string) => `Welcome back, ${fullName}!`,
  LOGIN_FAILED: 'Login failed. Please check your credentials and try again.',
  FORM_INVALID: 'Please fill in all required fields correctly.',

  // Financial Year Administration
  FINANCIAL_YEARS_LOAD_FAILED: 'Failed to load financial years from the server.',
  FINANCIAL_YEAR_FETCH_FAILED: 'Failed to fetch financial year details from the server.',
  FINANCIAL_YEAR_CREATED: (code: string) => `Financial Year '${code}' has been successfully created.`,
  FINANCIAL_YEAR_UPDATED: (code: string) => `Financial Year '${code}' has been successfully updated.`,
  FINANCIAL_YEAR_CREATE_FAILED: 'Failed to create financial year on the server.',
  FINANCIAL_YEAR_UPDATE_FAILED: 'Failed to update financial year on the server.',
  FINANCIAL_YEAR_SET_CURRENT_SUCCESS: (code: string) => `Financial Year '${code}' is now set as the current active financial year.`,
  FINANCIAL_YEAR_SET_CURRENT_FAILED: 'Failed to set financial year as current on the server.',
  FINANCIAL_YEAR_STATUS_UPDATED: (code: string, status: string) => `Financial Year '${code}' is now ${status}.`,
  FINANCIAL_YEAR_STATUS_UPDATE_FAILED: 'Failed to update financial year status on the server.',

  // Series Master Administration
  SERIES_MASTERS_LOAD_FAILED: 'Failed to load series masters from the server.',
  SERIES_MASTER_FETCH_FAILED: 'Failed to fetch series master details from the server.',
  SERIES_MASTER_CREATED: (code: string) => `Series '${code}' has been successfully created.`,
  SERIES_MASTER_UPDATED: (code: string) => `Series '${code}' has been successfully updated.`,
  SERIES_MASTER_CREATE_FAILED: 'Failed to create series master on the server.',
  SERIES_MASTER_UPDATE_FAILED: 'Failed to update series master on the server.',
  SERIES_MASTER_SET_DEFAULT_SUCCESS: (code: string) => `Series '${code}' is now set as default series.`,
  SERIES_MASTER_SET_DEFAULT_FAILED: 'Failed to set series master as default on the server.',
  SERIES_MASTER_STATUS_UPDATED: (code: string, status: string) => `Series '${code}' is now ${status}.`,
  SERIES_MASTER_STATUS_UPDATE_FAILED: 'Failed to update series status on the server.',

  // System Services Administration
  SERVICES_LOAD_FAILED: 'Failed to load services from the server.',
  SERVICE_FETCH_FAILED: 'Failed to fetch service details from the server.',
  SERVICE_CREATED: (name: string) => `Service '${name}' has been successfully created.`,
  SERVICE_UPDATED: (name: string) => `Service '${name}' has been successfully updated.`,
  SERVICE_DELETED: (name: string) => `Service '${name}' has been successfully deleted.`,
  SERVICE_CREATE_FAILED: 'Failed to create service on the server.',
  SERVICE_UPDATE_FAILED: 'Failed to update service on the server.',
  SERVICE_DELETE_FAILED: 'Failed to delete service from the server.',
  SERVICE_STATUS_UPDATED: (name: string, status: string) => `Service '${name}' is now ${status}.`,
  SERVICE_STATUS_UPDATE_FAILED: 'Failed to update service status on the server.',

  // System Modules Administration
  MODULES_LOAD_FAILED: 'Failed to load modules from the server.',
  MODULE_FETCH_FAILED: 'Failed to fetch module details from the server.',
  MODULE_CREATED: (name: string) => `Module '${name}' has been successfully created.`,
  MODULE_UPDATED: (name: string) => `Module '${name}' has been successfully updated.`,
  MODULE_DELETED: (name: string) => `Module '${name}' has been successfully deleted.`,
  MODULE_CREATE_FAILED: 'Failed to create module on the server.',
  MODULE_UPDATE_FAILED: 'Failed to update module on the server.',
  MODULE_DELETE_FAILED: 'Failed to delete module from the server.',
  MODULE_STATUS_UPDATED: (name: string, status: string) => `Module '${name}' is now ${status}.`,
  MODULE_STATUS_UPDATE_FAILED: 'Failed to update module status on the server.',

  // User Administration
  USERS_LOAD_FAILED: 'Failed to load users from the server.',
  USER_NOT_FOUND: 'The requested user account does not exist.',
  USER_CREATED: (username: string) => `User '${username}' has been successfully created.`,
  USER_UPDATED: (username: string) => `User '${username}' has been successfully updated.`,
  USER_DELETED: 'The user account has been successfully removed.',
  USER_DELETE_CONFIRM: 'Are you sure you want to permanently delete this user account? This action cannot be undone.',

  // Tenant Administration
  TENANTS_LOAD_FAILED: 'Failed to load tenants from the server.',
  TENANT_FETCH_FAILED: 'Failed to fetch tenant details from the server.',
  TENANT_CREATED: (name: string) => `Tenant '${name}' has been successfully created.`,
  TENANT_UPDATED: (name: string) => `Tenant '${name}' has been successfully updated.`,
  TENANT_DELETED: (name: string) => `Tenant '${name}' has been successfully deleted.`,
  TENANT_CREATE_FAILED: 'Failed to create tenant on the server.',
  TENANT_UPDATE_FAILED: 'Failed to update tenant on the server.',
  TENANT_DELETE_FAILED: 'Failed to delete tenant from the server.',
  TENANT_DELETE_CONFIRM: (name: string) => `Are you sure you want to permanently delete tenant '${name}'? This action cannot be undone.`,
  TENANT_STATUS_UPDATED: (name: string, status: string) => `Tenant '${name}' is now ${status}.`,

  // Organization Administration
  ORGANIZATIONS_LOAD_FAILED: 'Failed to load organizations from the server.',
  ORGANIZATION_FETCH_FAILED: 'Failed to fetch organization details from the server.',
  ORGANIZATION_CREATED: (name: string) => `Organization '${name}' has been successfully created.`,
  ORGANIZATION_UPDATED: (name: string) => `Organization '${name}' has been successfully updated.`,
  ORGANIZATION_DELETED: (name: string) => `Organization '${name}' has been successfully deleted.`,
  ORGANIZATION_CREATE_FAILED: 'Failed to create organization on the server.',
  ORGANIZATION_UPDATE_FAILED: 'Failed to update organization on the server.',
  ORGANIZATION_DELETE_FAILED: 'Failed to delete organization from the server.',
  ORGANIZATION_DELETE_CONFIRM: (name: string) => `Are you sure you want to permanently delete organization '${name}'? This action cannot be undone.`,
  ORGANIZATION_STATUS_UPDATED: (name: string, status: string) => `Organization '${name}' is now ${status}.`,

  // Location Administration
  LOCATIONS_LOAD_FAILED: 'Failed to load locations from the server.',
  LOCATION_FETCH_FAILED: 'Failed to fetch location details from the server.',
  LOCATION_CREATED: (name: string) => `Location '${name}' has been successfully created.`,
  LOCATION_UPDATED: (name: string) => `Location '${name}' has been successfully updated.`,
  LOCATION_DELETED: (name: string) => `Location '${name}' has been successfully deleted.`,
  LOCATION_CREATE_FAILED: 'Failed to create location on the server.',
  LOCATION_UPDATE_FAILED: 'Failed to update location on the server.',
  LOCATION_DELETE_FAILED: 'Failed to delete location from the server.',
  LOCATION_DELETE_CONFIRM: (name: string) => `Are you sure you want to permanently delete location '${name}'? This action cannot be undone.`,
  LOCATION_STATUS_UPDATED: (name: string, status: string) => `Location '${name}' is now ${status}.`,

  // Role Administration
  ROLES_LOAD_FAILED: 'Failed to load roles from the server.',
  ROLE_FETCH_FAILED: 'Failed to fetch role details from the server.',
  ROLE_CREATED: (name: string) => `Role '${name}' has been successfully created.`,
  ROLE_UPDATED: (name: string) => `Role '${name}' has been successfully updated.`,
  ROLE_CREATE_FAILED: 'Failed to create role on the server.',
  ROLE_UPDATE_FAILED: 'Failed to update role on the server.',
  ROLE_STATUS_UPDATED: (name: string, status: string) => `Role '${name}' is now ${status}.`,
  ROLE_STATUS_UPDATE_FAILED: 'Failed to update role status on the server.',

  // Location Type Administration
  LOCATION_TYPES_LOAD_FAILED: 'Failed to load location types from the server.',
  LOCATION_TYPE_FETCH_FAILED: 'Failed to fetch location type details from the server.',
  LOCATION_TYPE_CREATED: (name: string) => `Location type '${name}' has been successfully created.`,
  LOCATION_TYPE_UPDATED: (name: string) => `Location type '${name}' has been successfully updated.`,
  LOCATION_TYPE_CREATE_FAILED: 'Failed to create location type on the server.',
  LOCATION_TYPE_UPDATE_FAILED: 'Failed to update location type on the server.',
  LOCATION_TYPE_STATUS_UPDATED: (name: string, status: string) => `Location type '${name}' is now ${status}.`,
  LOCATION_TYPE_STATUS_UPDATE_FAILED: 'Failed to update location type status on the server.',

  // Item Category Administration
  ITEM_CATEGORIES_LOAD_FAILED: 'Failed to load item categories from the server.',
  ITEM_CATEGORY_FETCH_FAILED: 'Failed to fetch item category details from the server.',
  ITEM_CATEGORY_CREATED: (name: string) => `Item category '${name}' has been successfully created.`,
  ITEM_CATEGORY_UPDATED: (name: string) => `Item category '${name}' has been successfully updated.`,
  ITEM_CATEGORY_CREATE_FAILED: 'Failed to create item category on the server.',
  ITEM_CATEGORY_UPDATE_FAILED: 'Failed to update item category on the server.',
  ITEM_CATEGORY_STATUS_UPDATED: (name: string, status: string) => `Item category '${name}' is now ${status}.`,
  ITEM_CATEGORY_STATUS_UPDATE_FAILED: 'Failed to update item category status on the server.',

  // Item Brand Administration
  ITEM_BRANDS_LOAD_FAILED: 'Failed to load item brands from the server.',
  ITEM_BRAND_FETCH_FAILED: 'Failed to fetch item brand details from the server.',
  ITEM_BRAND_CREATED: (name: string) => `Item brand '${name}' has been successfully created.`,
  ITEM_BRAND_UPDATED: (name: string) => `Item brand '${name}' has been successfully updated.`,
  ITEM_BRAND_CREATE_FAILED: 'Failed to create item brand on the server.',
  ITEM_BRAND_UPDATE_FAILED: 'Failed to update item brand on the server.',
  ITEM_BRAND_STATUS_UPDATED: (name: string, status: string) => `Item brand '${name}' is now ${status}.`,
  ITEM_BRAND_STATUS_UPDATE_FAILED: 'Failed to update item brand status on the server.',

  // Menu Administration
  MENUS_LOAD_FAILED: 'Failed to load menus from the server.',
  MENU_FETCH_FAILED: 'Failed to fetch menu details from the server.',
  MENU_CREATED: (name: string) => `Menu '${name}' has been successfully created.`,
  MENU_UPDATED: (name: string) => `Menu '${name}' has been successfully updated.`,
  MENU_CREATE_FAILED: 'Failed to create menu on the server.',
  MENU_UPDATE_FAILED: 'Failed to update menu on the server.',
  MENU_STATUS_UPDATED: (name: string, status: string) => `Menu '${name}' is now ${status}.`,
  MENU_STATUS_UPDATE_FAILED: 'Failed to update menu status on the server.',

  // Server/Connection Errors
  UNAUTHORIZED: 'Your session has expired. Please log in again.',
  FORBIDDEN: 'You do not have permission to access this resource.',
  CONNECTION_FAILED: 'The server is still refusing connections. Please try again shortly.',
  SERVER_ERROR_DETAIL: 'The server is still refusing connections. Please try again shortly.',
} as const;
